import styled from 'styled-components';

export const EditVehicleTypeContainer = styled.section`
  width: 100%;
  height: fit-content;
`;
